<div>
    <div class="image-info" *ngIf="isDialog && imageInfo?.startDate">
        <h3 class="flex">
            <mat-icon fontIcon="image" class="info-icon"></mat-icon>
            {{ 'title.gallery' | translate }}
        </h3>

        <div class="flex">
            <mat-icon fontIcon="schedule" class="info-icon"
                matTooltip="{{ 'datatable.createdDate' | translate }}"></mat-icon>
            : {{ imageInfo.startDate | timeFormat : 'yyyy/MM/dd HH:mm:ss'}}
        </div>

        <lib-button color="none" textColor="muted" icon="close" (click)="closeGallery()"></lib-button>
    </div>

    <div class="picture-container" [class.in-dialog]="isDialog" [class.fit-image]="isDialog || maxImageHeight"
        [style.maxWidth]="isDialog || maxImageHeight ? null : currentWidth"
        [style.height]="isDialog || maxImageHeight ? null : currentHeight">
        <div class="icon-buttons noDialog" *ngIf="!isDialog">
            <button mat-icon-button [matTooltip]="'form.crane_cycle' | translate" matTooltipPosition="above"
                (click)="switchProject('crane')" [ngClass]="{
              active: currentTagProject=='crane',
              disabled: isButtonDisabled('crane')
            }" [disabled]="isButtonDisabled('crane')" *ngIf="isButtonVisible('crane')">
                <mat-icon class="small">format_shapes</mat-icon>
            </button>

            <button *ngIf="isButtonVisible('risk')" mat-icon-button [matTooltip]="'form.risk' | translate"
                matTooltipPosition="above" class="up" (click)="switchProject('risk')" [ngClass]="{
              active: currentTagProject=='risk',
              disabled: isButtonDisabled('risk')
            }" [disabled]="isButtonDisabled('risk')">
                <mat-icon>error</mat-icon>
            </button>

            <button *ngIf="isButtonVisible('worker')" mat-icon-button [matTooltip]="'form.workers' | translate"
                matTooltipPosition="above" (click)="switchProject('worker')" [ngClass]="{
              active: currentTagProject=='worker',
              disabled: isButtonDisabled('worker')
            }" [disabled]="isButtonDisabled('worker')">
                <mat-icon>directions_walk</mat-icon>
            </button>

            <button mat-icon-button [matTooltip]="'form.zone' | translate" matTooltipPosition="above"
                (click)="switchProject('zone')" [ngClass]="{
              active: currentTagProject=='zone',
              disabled: isButtonDisabled('zone')
            }" [disabled]="isButtonDisabled('zone')" *ngIf="isButtonVisible('zone')">
                <mat-icon>place</mat-icon>
            </button>

            <button mat-icon-button [matTooltip]="'form.action' | translate" matTooltipPosition="above" class="up right"
                (click)="switchProject('action')" [ngClass]="{
              active: currentTagProject=='action',
              disabled: isButtonDisabled('action')
            }" [disabled]="isButtonDisabled('action')" *ngIf="isButtonVisible('action')">
                <mat-icon>more</mat-icon>
            </button>
        </div>

        <div class="select-div" [ngClass]="{'top-0': isDialog }">
            <lib-search-select *ngIf="currentTagProject == 'action'" [items]="tagNames.action"
                [selectedItem]="selectedTags['action']" [label]="'form.action'" [noFloatLabel]="true"
                [backgroundColor]="'rgba(0, 0, 0, 0.4)'" [searchPlaceholder]="'form.search_action'"
                [valueColor]="'#fff'" (itemChanged)="onActionChanged($event)" class="action-select">
            </lib-search-select>

            <lib-search-select *ngIf="currentTagProject == 'zone'" [items]="tagNames.zone"
                [selectedItem]="selectedTags['zone']" [label]="'form.zone'" [noFloatLabel]="true"
                [backgroundColor]="'rgba(0, 0, 0, 0.4)'" [searchPlaceholder]="'form.search_zone'" [valueColor]="'#fff'"
                (itemChanged)="onZoneChanged($event)" class="zone-select">
            </lib-search-select>
        </div>

        <div class="classify-container" *ngIf="classifications.length">
            <ng-container *ngFor="let classifyTag of classifications; trackBy: trackByClassificationId">
                <div class="classify-item" *ngIf="shouldDisplayClassification(classifyTag)">
                    <div class="project {{classifyTag.project}}">
                        {{classifyTag.project}}
                    </div>

                    <div class="tag">
                        {{classifyTag.tagName}}
                    </div>

                    <div *ngIf="classifyTag.probability < 1" class="probability">
                        {{round(classifyTag.probability)}}
                    </div>

                    <mat-icon *ngIf="classifyTag.probability == 1 && !getLoading(classifyTag)" name="close"
                        class="close" color="warn" (click)="removeClassification(classifyTag)" fontIcon="delete">
                    </mat-icon>

                    <div class="loading" *ngIf="classifyTag.probability==1 && getLoading(classifyTag)">
                        <mat-spinner [diameter]="20" color="warn"></mat-spinner>
                    </div>
                </div>
            </ng-container>
        </div>

        <div [id]="'box-drawer-'+id" class="box-drawer" [style.left]="0" [style.top]="0" [style.width]="'100%'"
            [style.height]="'100%'" [style.zIndex]="getDrawerZIndex()" #boxDrawer></div>

        <div *ngIf="currentBox" class="box box-tag" [style.left]="currentBox.boundingBox.left+'px'"
            [style.top]="currentBox.boundingBox.top+'px'" [style.width]="currentBox.boundingBox.width+'px'"
            [style.height]="currentBox.boundingBox.height+'px'" [style.zIndex]="10"
            [ngClass]="{'risk-box': currentTagProject=='risk', 'worker-box': currentTagProject=='worker'}">
            <div class="close-tag">
                <input #input *ngIf="currentBox.done && !mousedown" type="text" class="prediction-select"
                    [(ngModel)]="currentBox.displayName" (ngModelChange)="onPredictionChanged($event)">

                <lib-button *ngIf="!mousedown" textColor="warning" color="none" (click)="resetPredictionBox()"
                    class="close-button" icon="close">
                </lib-button>
            </div>

            <select #select *ngIf="predictions.length && !mousedown" type="text" class="prediction-select"
                (click)="setPredictionChanged($event)">
                <option *ngFor="let prediction of predictions">{{ getDisplayName(prediction)}}</option>
            </select>

            <div class="description-container">
                <textarea #textarea *ngIf="currentTagProject=='risk' && currentBox.done && !mousedown"
                    class="description prediction-select" [(ngModel)]="currentBox.description"
                    (ngModelChange)="onDescriptionChanged($event)" placeholder="Description...">
            </textarea>
            </div>
        </div>

        <img [src]="url + (processed ? randomStr : '')" class="attachment-picture" [style.maxHeight]="maxImageHeight" (load)="onImgLoaded($event)" />

        <ng-container class="boxes-container" *ngFor="let box of boxes; let index = index; trackBy: trackByBoxId">
            <span *ngIf="shouldDisplayTag(box)" class="tag-name"
                [style.top]="'calc(' + box.boundingBox.top * 100 + '% - 20px)'" [style.left]="getTagPosition(box)">
                {{box.displayName}} ({{(box.probability * 100).toFixed() +'%'}})
            </span>

            <div class="box" *ngIf="shouldDisplayTag(box)" [style.left]="box.boundingBox.left * 100 +'%'"
                [style.top]="box.boundingBox.top * 100 +'%'" [style.width]="box.boundingBox.width * 100 +'%'"
                [style.height]="box.boundingBox.height * 100 +'%'"
                [ngClass]="{'risk-box': isRiskTag(box), 'worker-box': isWorkerTag(box)}">
                <mat-icon
                    *ngIf="(box.probability==1 && !getLoading(box) && !isWorkerTag(box) && !isRiskTag(box)) || (box.probability==1 && !getLoading(box) && isWorkerTag(box) && isAdmin() && !isRiskTag(box))"
                    name="close" class="close" (click)="removeBox(index)" fontIcon="delete">
                </mat-icon>

                <mat-spinner *ngIf="box.probability==1 && getLoading(box)" [diameter]="14" class="loading"
                    color="warn"></mat-spinner>

                <mat-icon *ngIf="box.description" class="description-icon" #tooltip="matTooltip"
                    matTooltip="{{box.description}}" aria-label="Button that displays the risk description"
                    [matTooltipPosition]="'left'" fontIcon="info">
                </mat-icon>

                <span class="risk-number" *ngIf="riskNumbers && box._id && riskNumbers[box._id]">
                    {{ riskNumbers[box._id] }}
                </span>
            </div>
        </ng-container>
    </div>

    <div class="btn-group" *ngIf="isDialog">
        <button *ngIf="!data.disableArrow" mat-icon-button (click)="prevImage()">
            <mat-icon>arrow_left</mat-icon>
        </button>

        <button mat-icon-button (click)="editTags()" [matTooltip]="'events.edit_tags' | translate"
            matTooltipPosition="above" class="edit-btn primary">
            <mat-icon>edit</mat-icon>
        </button>

        <div class="icon-buttons-bottom">
            <button mat-icon-button [matTooltip]="'form.crane_cycle' | translate" matTooltipPosition="above"
                (click)="switchProject('crane')" [ngClass]="{
                  active: currentTagProject=='crane',
                  disabled: isButtonDisabled('crane')
                }" [disabled]="isButtonDisabled('crane')" *ngIf="isButtonVisible('crane')">
                <mat-icon>format_shapes</mat-icon>
            </button>

            <button *ngIf="isButtonVisible('risk')" mat-icon-button [matTooltip]="'form.risk' | translate"
                matTooltipPosition="above" class="up" (click)="switchProject('risk')" [ngClass]="{
                  active: currentTagProject=='risk',
                  disabled: isButtonDisabled('risk')
                }" [disabled]="isButtonDisabled('risk')">
                <mat-icon>error</mat-icon>
            </button>

            <button *ngIf="isButtonVisible('worker')" mat-icon-button [matTooltip]="'form.workers' | translate"
                matTooltipPosition="above" (click)="switchProject('worker')" [ngClass]="{
                  active: currentTagProject=='worker',
                  disabled: isButtonDisabled('worker')
                }" [disabled]="isButtonDisabled('worker')">
                <mat-icon>directions_walk</mat-icon>
            </button>

            <button mat-icon-button [matTooltip]="'form.zone' | translate" matTooltipPosition="above"
                (click)="switchProject('zone')" [ngClass]="{
                  active: currentTagProject=='zone',
                  disabled: isButtonDisabled('zone')
                }" [disabled]="isButtonDisabled('zone')" *ngIf="isButtonVisible('zone')">
                <mat-icon>place</mat-icon>
            </button>

            <button mat-icon-button [matTooltip]="'form.action' | translate" matTooltipPosition="above" class="right"
                (click)="switchProject('action')" [ngClass]="{
                  active: currentTagProject=='action',
                  disabled: isButtonDisabled('action')
                }" [disabled]="isButtonDisabled('action')" *ngIf="isButtonVisible('action')">
                <mat-icon>more</mat-icon>
            </button>
        </div>

        <button *ngIf="!data.disableArrow" mat-icon-button (click)="nextImage()">
            <mat-icon>arrow_right</mat-icon>
        </button>
    </div>
</div>